// Set stock status on load

$(document).on('change', '.variations input[type="radio"]', function(e) {
  console.log(e);
});

console.log($('.variations_form').data('product_variations'));

